import {
  // Calculation actions
  FETCH_CALCULATIONS_REQUEST,
  FETCH_CALCULATIONS_SUCCESS,
  FETCH_CALCULATIONS_FAILURE,
  FETCH_CALCULATION_REQUEST,
  FETCH_CALCULATION_SUCCESS,
  FETCH_CALCULATION_FAILURE,
  CREATE_CALCULATION_REQUEST,
  CREATE_CALCULATION_SUCCESS,
  CREATE_CALCULATION_FAILURE,
  UPDATE_CALCULATION_REQUEST,
  UPDATE_CALCULATION_SUCCESS,
  UPDATE_CALCULATION_FAILURE,
  DELETE_CALCULATION_REQUEST,
  DELETE_CALCULATION_SUCCESS,
  DELETE_CALCULATION_FAILURE,
  
  // Calculation Item actions
  FETCH_CALCULATION_ITEMS_REQUEST,
  FETCH_CALCULATION_ITEMS_SUCCESS,
  FETCH_CALCULATION_ITEMS_FAILURE,
  CREATE_CALCULATION_ITEM_SUCCESS,
  UPDATE_CALCULATION_ITEM_SUCCESS,
  DELETE_CALCULATION_ITEM_SUCCESS,
  
  // Import actions
  IMPORT_CALCULATION_OLD_REQUEST,
  IMPORT_CALCULATION_OLD_SUCCESS,
  IMPORT_CALCULATION_OLD_FAILURE,
  
  // UI actions
  SELECT_CALCULATION,
  CLEAR_SELECTED_CALCULATION
} from './action-types';

const initialState = {
  // API response data
  data: {
    value: [],
    page: 0,
    size: 10,
    totalCount: 0,
    totalPages: 0
  },
  loading: false,
  error: null,
  params: {},
  
  // Current calculation
  current: {
    data: null,
    loading: false,
    error: null
  },
  
  // Current calculation details
  currentCalculation: null,
  
  // Calculation items
  items: {
    byCalculationId: {},
    loading: false,
    error: null
  },
  
  // UI state
  ui: {
    selectedCalculation: null
  }
};

const calculationsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Calculations
    case FETCH_CALCULATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        params: action.payload || {}
      };
      
    case FETCH_CALCULATIONS_SUCCESS:
      return {
        ...state,
        data: {
          value: action.payload.value || [],
          page: action.payload.page || 0,
          size: action.payload.size || 10,
          totalCount: action.payload.totalCount || 0,
          totalPages: action.payload.totalPages || 0
        },
        loading: false,
        error: null
      };
      
    case FETCH_CALCULATIONS_FAILURE:
      return {
        ...state,
        data: {
          ...state.data,
          value: [],
          totalCount: 0
        },
        loading: false,
        error: action.payload
      };
      
    // Fetch Single Calculation
    case FETCH_CALCULATION_REQUEST:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          error: null
        }
      };
      
    case FETCH_CALCULATION_SUCCESS:
      const calculation = {
        id: action.payload.id,
        createdAt: action.payload.createdAt,
        calculationName: action.payload.calculationName,
        transportationValues: action.payload.transportationValues || [],
        forwardingAgentValues: action.payload.forwardingAgentValues || [],
        totalSellSum: action.payload.totalSellSum || 0,
        totalStockPrice: action.payload.totalStockPrice || 0,
        productProfit: action.payload.productProfit || 0,
        items: action.payload.items?.map(item => ({
          id: item.id,
          createdAt: item.createdAt,
          productCode: item.productCode,
          productDescription: item.productDescription,
          quantity: item.quantity,
          listPrice: item.listPrice,
          buyPrice: item.buyPrice,
          stockPrice: item.stockPrice,
          sellPrice: item.sellPrice,
          customsValue: item.customsValue,
          customsAvailability: item.customsAvailability,
          itemProfit: item.itemProfit,
          grandTotalSell: item.grandTotalSell,
          grandTotalStockPrice: item.grandTotalStockPrice
        })) || []
      };
      
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: calculation,
          error: null
        },
        currentCalculation: calculation
      };
      
    case FETCH_CALCULATION_FAILURE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.payload
        }
      };
      
    // Create Calculation
    case CREATE_CALCULATION_REQUEST:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          error: null
        }
      };
      
    case CREATE_CALCULATION_SUCCESS:
      const createdCalculation = {
        id: action.payload.id,
        createdAt: action.payload.createdAt,
        calculationName: action.payload.calculationName,
        transportationValues: action.payload.transportationValues || [],
        forwardingAgentValues: action.payload.forwardingAgentValues || [],
        totalSellSum: action.payload.totalSellSum || 0,
        totalStockPrice: action.payload.totalStockPrice || 0,
        productProfit: action.payload.productProfit || 0,
        items: action.payload.items || []
      };
      
      return {
        ...state,
        data: {
          ...state.data,
          value: [createdCalculation, ...state.data.value],
          totalCount: state.data.totalCount + 1
        },
        current: {
          ...state.current,
          loading: false,
          data: createdCalculation
        },
        currentCalculation: createdCalculation
      };
      
    case CREATE_CALCULATION_FAILURE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.payload
        }
      };
      
    // Update Calculation
    case UPDATE_CALCULATION_REQUEST:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          error: null
        }
      };
      
    case UPDATE_CALCULATION_SUCCESS:
      const updatedCalculation = {
        id: action.payload.id,
        createdAt: action.payload.createdAt,
        calculationName: action.payload.calculationName,
        transportationValues: action.payload.transportationValues || [],
        forwardingAgentValues: action.payload.forwardingAgentValues || [],
        totalSellSum: action.payload.totalSellSum || 0,
        totalStockPrice: action.payload.totalStockPrice || 0,
        productProfit: action.payload.productProfit || 0,
        items: action.payload.items?.map(item => ({
          id: item.id,
          createdAt: item.createdAt,
          productCode: item.productCode,
          productDescription: item.productDescription,
          quantity: item.quantity,
          listPrice: item.listPrice,
          buyPrice: item.buyPrice,
          stockPrice: item.stockPrice,
          sellPrice: item.sellPrice,
          customsValue: item.customsValue,
          customsAvailability: item.customsAvailability,
          itemProfit: item.itemProfit,
          grandTotalSell: item.grandTotalSell,
          grandTotalStockPrice: item.grandTotalStockPrice
        })) || []
      };
      
      return {
        ...state,
        data: {
          ...state.data,
          value: state.data.value.map(calc => 
            calc.id === updatedCalculation.id ? updatedCalculation : calc
          )
        },
        current: {
          ...state.current,
          loading: false,
          data: updatedCalculation
        },
        currentCalculation: updatedCalculation,
        ui: {
          ...state.ui,
          selectedCalculation: updatedCalculation
        }
      };
      
    case UPDATE_CALCULATION_FAILURE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.payload
        }
      };
      
    // Delete Calculation
    case DELETE_CALCULATION_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null
        }
      };
      
    case DELETE_CALCULATION_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          items: state.list.items.filter(calc => calc.id !== action.payload.id),
          totalCount: Math.max(0, state.list.totalCount - 1)
        },
        current: state.current.data?.id === action.payload.id 
          ? { data: null, loading: false, error: null }
          : state.current
      };
      
    case DELETE_CALCULATION_FAILURE:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.payload
        }
      };
      
    // Fetch Calculation Items
    case FETCH_CALCULATION_ITEMS_REQUEST:
      return {
        ...state,
        items: {
          ...state.items,
          loading: true,
          error: null
        }
      };
      
    case FETCH_CALCULATION_ITEMS_SUCCESS:
      return {
        ...state,
        items: {
          ...state.items,
          loading: false,
          byCalculationId: {
            ...state.items.byCalculationId,
            [action.meta.calculationId]: action.payload
          }
        }
      };
      
    case FETCH_CALCULATION_ITEMS_FAILURE:
      return {
        ...state,
        items: {
          ...state.items,
          loading: false,
          error: action.payload
        }
      };
      
    // Create Calculation Item
    case CREATE_CALCULATION_ITEM_SUCCESS: {
      const calculationId = action.payload.calculationId;
      const currentItems = state.items.byCalculationId[calculationId] || [];
      
      return {
        ...state,
        items: {
          ...state.items,
          byCalculationId: {
            ...state.items.byCalculationId,
            [calculationId]: [...currentItems, action.payload]
          }
        }
      };
    }
    
    // Update Calculation Item
    case UPDATE_CALCULATION_ITEM_SUCCESS: {
      const calculationId = action.payload.calculationId;
      const currentItems = state.items.byCalculationId[calculationId] || [];
      
      return {
        ...state,
        items: {
          ...state.items,
          byCalculationId: {
            ...state.items.byCalculationId,
            [calculationId]: currentItems.map(item => 
              item.id === action.payload.id ? action.payload : item
            )
          }
        }
      };
    }
    
    // Delete Calculation Item
    case DELETE_CALCULATION_ITEM_SUCCESS: {
      const { calculationId, itemId } = action.payload;
      const currentItems = state.items.byCalculationId[calculationId] || [];
      
      return {
        ...state,
        items: {
          ...state.items,
          byCalculationId: {
            ...state.items.byCalculationId,
            [calculationId]: currentItems.filter(item => item.id !== itemId)
          }
        }
      };
    }
    
    // UI Actions
    case SELECT_CALCULATION:
      return {
        ...state,
        ui: {
          ...state.ui,
          selectedCalculation: action.payload
        }
      };
      
    case CLEAR_SELECTED_CALCULATION:
      return {
        ...state,
        ui: {
          ...state.ui,
          selectedCalculation: null
        }
      };
    
    // Import Calculation Old
    case IMPORT_CALCULATION_OLD_REQUEST:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          error: null
        }
      };
      
    case IMPORT_CALCULATION_OLD_SUCCESS:
      const importedCalculation = {
        id: action.payload.id,
        createdAt: action.payload.createdAt,
        calculationName: action.payload.calculationName,
        transportationValues: action.payload.transportationValues || [],
        forwardingAgentValues: action.payload.forwardingAgentValues || [],
        totalSellSum: action.payload.totalSellSum || 0,
        totalStockPrice: action.payload.totalStockPrice || 0,
        productProfit: action.payload.productProfit || 0,
        items: action.payload.items || [],
        createdBy: action.payload.createdBy,
        lastUpdatedBy: action.payload.lastUpdatedBy
      };
      
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: importedCalculation
        },
        currentCalculation: importedCalculation
      };
      
    case IMPORT_CALCULATION_OLD_FAILURE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.payload
        }
      };
      
    default:
      return state;
  }
};

export default calculationsReducer;
